import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {setNotice} from '../../actions';


class Notice extends Component {
  constructor(props){
    super(props);
    this.state = {
      classes: "alert-wrap is-visible"
    };
    this.timer = null;
  }

  componentDidMount() {
    this.timer = setTimeout(this.hideImmediately.bind(this), 1000 * 2);
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  hideImmediately(){
    this.setState({classes: "alert-wrap is-hidden"}, () => {
      this.props.setNotice(false, '', '');
    });
  }


  render() {
    const {noticeState, noticeContent} = this.props;
    const alertClasses = noticeState.toLowerCase().includes('success')
                      ? 'alert-notice success' : 'alert-notice failure';
    return ReactDOM.createPortal(
      <div className={this.state.classes} onClick={this.hideImmediately.bind(this)}>
        <div className={alertClasses}>
          <span className='content'>{noticeContent}</span>
        </div>
      </div>
      , document.getElementById("root"));
  }
};
const mapStateToProps = state => {
  return {
    noticeState: state.noticeState,
    noticeContent: state.noticeContent
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    setNotice: (flag, state, content) => dispatch(setNotice(flag, state, content))
  }
}

Notice = connect(mapStateToProps, mapDispatcherToProps)(Notice)

export default Notice;



// WEBPACK FOOTER //
// ./src/components/modal/Notice.js